<template>
    <div class="app-container">
        <p class="container-title">
            文登整骨烟台医院 <br>健康管理中心
        </p>

        <div class="yzm-container">
         
            <p class="desc-title">快去关注公众号了解一下吧</p>
            <div class="yzm">
                <img src="http://cxoplus.cn/api/hospapi/event/qr/28438.jpg" >
            </div>
            <div class="hr-box" ></div>
            <div class="steps">
                <p class="item">
                    <span class="label">1</span>
                    <span class="txt">请截图保存二维码</span>
                </p>
                <p class="item">
                    <span class="label">2</span>
                    <span class="txt">使用微信扫一扫</span>
                </p>
                <p class="item">
                    <span class="label">3</span>
                    <span class="txt">关注公众号</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { config_get } from "@/api/user"
export default {
    data () {
        return {
            securityCode:this.$route.query.securityCode,
            patientName:this.$route.query.patientName,
            eventId:this.$route.query.eventId,
            emergencyContactMethod1:""
        }
    },
    created () {
        document.title = "文登整骨烟台医院"
       
    },
    methods:{
        copyText() {
            var oInput = document.createElement('input');     //创建一个隐藏input
            oInput.value = this.securityCode;    //赋值
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            oInput.className = 'oInput';
            oInput.style.display='none';
            oInput.remove();
            this.$toast(this.$t("comonTxt.copysuccess"))
        },
    }
}
</script>

<style lang="less" scoped>
.app-container{
    height: 100%;
    width: 100%;
    background: url("~@/assets/img/emergencyContact2.png") no-repeat;
    background-size: 100% 7.8rem;
    background-position: 0 0;
    background-color: #4AA9FF;
    overflow: auto;
    .container-title{
   
        font-size: 1.28rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FEFEFE;
        line-height: 1.8rem;
        text-shadow: 0 0.06rem 0.12rem #054DD2;
        width: max-content;
        margin: 1.4rem  auto 1rem auto;
    }
    .yzm-container{
        margin: 0 0.8rem 0.4rem 0.8rem;
        background: #FFFFFF;
        padding: 1.2rem 0.65rem 1.2rem 0.65rem;
        position: relative;
        border-radius: 20px;
        box-shadow: -0.04rem 0 0.2rem #cce1f5 inset;
        .desc{
            font-size: 0.6rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 0.84rem;
        }
        .mode{
            position: absolute;
            background: #D0E9FF;
            top: 0;
            left: 0;
            height: 1.2rem;
            border-radius: 0.4rem 0 0.4rem 0;
            padding: 0 0.6rem;
            line-height: 1.2rem;
            font-size: 0.72rem;
            font-family: PingFang SC;
            font-weight: 600;
            font-style: italic;
            color: #49A3FF;
        }
        .yam-txt{
            display: flex;
            align-items: center;
            justify-content: center;
            .txt{
                font-size: 1.12rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
            }
            .copy{
                padding: 0.2rem 0.48rem;
                font-size: 0.56rem;
                font-family: PingFang SC;
                font-weight: 500;
                background: #49A3FF;
                border-radius: 0.5rem;
                margin-left: 0.2rem;
                color: #FFFFFF;
            }
        }
        .desc-title{
            width: max-content;
            padding: 0 1.2rem;
            background: url("~@/assets/img/desc-title-back.png") no-repeat;
            background-size: 100% auto;
            font-size: 0.56rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 0.6rem;
            margin: 0 auto 0.96rem auto;
            background-position: bottom;
        }
        .hr-box{
            width: 10.8rem;
            border-bottom: 0.06rem dashed #AEB7B9;
            margin: 1rem auto;
            position: relative;
            &::after,&::before{
                width: 0.6rem;
                height: 0.6rem;
                border-radius: 50%;
                content: ' ';
                position: absolute;
                top: 50%;
                transform: translate(0,-50%);
                left: -15%;
                background: #00abff;
            }
            &::before{
                left: auto;
                right: -15%;
            }
        }
        .yzm{
            width: 8rem;
            height: 8.12rem;
            margin: 0 auto 1rem auto;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .hr-emtry{
            margin: 1.2rem 0.6rem;
            border-bottom: 0.04rem dashed #AEB7B9;
            position: relative;
            &::after,&::before{
                position: absolute;
                width: 0.6rem;
                height: 0.6rem; 
                background: #4AA9FF;
                content: ' ';
                border-radius: 50% ;
                top: 50%;
                transform: translate(0,-50%);
            }
            &::after{
                left: -1.55rem;
            }
            &::before{
                right:  -1.55rem;
            }
        }
        .steps{
            width: max-content;
            margin: 0 auto;
            .item{
                display: flex;
                align-items: flex-start;
                margin-bottom: 0.6rem;
                &:last-child{
                    margin-bottom: 0;
                }
                .label{
                    margin-right: 0.2rem;
                    width: 0.6rem;
                    flex: 0 0 auto;
                    height: 0.6rem;
                    display: inline-block;
                    text-align: center;
                    line-height: 0.6rem;
                    background: #49A3FF;
                    border-radius: 50%;
                    font-size: 0.48rem;
                    font-family: PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                }
                .txt{
                    font-size: 0.56rem;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 0.64rem;
                    color: #333333;
                }
            }
        }
    }
   
    .wayone{
        position: relative;
        z-index: 9;
        &::after{
            left: 50%;
            transform: translate(-50%,0);
            bottom: -1.3rem;
            content:  ' ';
            width: 2.3rem;
            height: 2.3rem;
            position: absolute;
            background: url("~@/assets/img/or-icon.png") no-repeat;
            background-size: 100% 100%;
        }
    }
}
</style>